import axios from 'axios'

const BASE_URL = "https://vms-videos.minutemediaservices.com"

const client = axios.create({
    baseURL: BASE_URL,
    json: true
})

const perform = async (method, resource, params, data) =>  {
    return client({
      method,
      url: resource,
      params,
      data
    }).then(resp => {
      if (resp.status === 200) {
        return resp.data
      }
      else {
        let requestData = (method === 'get') ? params : data
        reportApiError(method, `${resource}`, requestData, `${resp.status}`)
      }
    }).catch(function(reason) {
        let requestData = (method === 'get') ? params : data
        reportApiError(method, `${reason.config.baseURL}${resource}`, requestData, `${reason.response ? reason.response.status : reason.message}`)
    })
}

const reportApiError = (method, requestUrl, requestData, status) => {
    requestData = requestData ? requestData : {}
    let errorMsg = `bad response for ${method.toUpperCase()} ${requestUrl} - requestData: ${JSON.stringify(requestData)} - status ${status}`
    console.log(errorMsg)
    throw errorMsg
}

const ApiClient = {
    getPlaylist: async playlistId => {
        return perform('get', `/${playlistId}/${playlistId}.json`)
    }
}

export default ApiClient